import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
    //state设置是属性，(用来存储数据)
    state: {
        axisLineColor: '#696a7e', //轴线颜色
        axisLabelColor: '#fff', //轴文字颜色 #ccd0f2
        splitLineStyle:{ //网格线
            color: '#555e86',
            type: 'dashed'
        },
        legendTextColor: '#fff' , //图例文字颜色
        colorArr:[], //颜色组
    },
    //getters对应的方法，(用来获取state的属性的状态)
    getters: {
        // getOemForm: state => state.oemForm
    },

    //mutations用来
    mutations: {
    },
    //actions不直接操作，运用mutations
    actions: {
    }
})
export default store